import PriorityBadge from "../../components/Layout/PriorityBadge";

import {
  clearScanData,
  getManualAuthentication,
  getScanDataFromWebhostQR,
} from "../../network/apiService";
import {
  CONFIG_MASTER_ENUM,
  STEP_CONFIG_ENUM,
  STEP_MASTER_ENUM,
} from "../../constants/constant";
import {
  timerConstantValue,
} from "../../constants/timers";
import {
  FACE_VERIFICATION,
 FACE_VERIFICATION_KEY,
  KEY,
  KEY_NEW,
  RESERVATION_LIST_FORM,
} from "../../routes/Paths";
import React, { useRef, useState, useEffect } from "react";
import {
  fetchProfiles,
  fetchProfilesForKeyPickup,
  fetchReservation,
} from "../../store/Checkin/reservationformSlice";
import {
  formatDate,
  formatSysDate,
  getConfigurationCode,
  getParametersFromLocalStorage,
  getStepMaster,
  homePageHandler,
  saveIntoLocalStorage,
} from "../../helpers/commonHelper";
import { useDispatch, useSelector } from "react-redux";
import ManualAuthenticationModal from "../../components/Layout/Card/ManualAuthenticationModal";
import { fetchProfileDocuments } from "../../network/apiService";

import CheckInCheckOutToggleForm from "../../components/Forms/CheckInCheckOutToggleForm";
import ErrorPopup from "../../components/LoaderAndNotification/ErrorPopup";
import Footer from "../../components/Layout/Footer";
import Header from "../../components/Layout/Header";
import HomePageCard from "../../components/Layout/Card/HomePageCard";
import KeyFooter from "../../components/Layout/KeyFooter";
import LoaderPopup from "../../components/LoaderAndNotification/LoaderPopup";
import { getModuleConfiguration } from "../../store/Checkin/moduleConfigurationSlice";
import { getPropertyInfo } from "../../store/Checkin/Scan/propertySlice";
import { getReservationDetails } from "../../network/apiService";
import { getSelectedLanguage } from "../../store/Checkin/languageSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { userReservationDetailsCheckoutPage } from "../../store/Checkout/checkoutSlice";
import {
  getPassportScanData,
  userReservationDetailsPassport,
} from "../../store/Checkin/Scan/scanPassportSlice";
import { postAuditLog } from "../../store/stageSlice";
import useUserActivity from "../../hooks/useUserActivity";


const KeyReservationSearch = () => {
  const reservationRef = useRef(null);
  const userData = useSelector(getPassportScanData);
  const [showManualAuthModal, setShowManualAuthModal] = useState(false);
  const handleManualAuthProceed = () => {
    setShowManualAuthModal(false);
    navigate("/manual-authentication"); // or wherever your manual flow starts
  };

  const handleManualAuthCancel = () => {
    setShowManualAuthModal(false);
    setTimeout(() => {
      handlebackPage();
    }, 4000);
  };
  useEffect(() => {
    // if (!userData) {
    //   addLog("userData is undefined", "false", "ReservationSearch selector returned no guest data");
    // } else {
    addLog(
      JSON.stringify(userData),
      "true",
      "KeyReservationSearch userData loaded"
    );
    //}
  }, [userData]);

  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);

  const timeLimit = timerConstantValue;
  const [showModal, setShowModal] = useState(false);
  const [confirmationNumberData, setConfirmationNumberData] = useState({
    lastName: "",
    confirmationNumber: "",
    checkoutDate: "",
  });
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const [loading, setLoading] = useState(false);
  const [timerValue, setTimerValue] = useState(timeLimit);
  const [restartTimer, setRestartTimer] = useState(false);

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const calendarRef = useRef(null);

  const [erroModalData, setErrorModalData] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const propertyData = useSelector(getPropertyInfo);

  const stepMaster = useSelector((state) => getModuleConfiguration(state));
  // const stepConfigs = [
  //   {
  //     stepConfigurationCode: STEP_CONFIG_ENUM.LASTNAME_CHKDT,
  //     stepConfigurationName: "",
  //   },
  // ];
  const stepConfigs = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.KEY_ENCODE_PAGE
  );

  const stepConfigsKey = getStepMaster(stepMaster, STEP_MASTER_ENUM.KEY_SEARCH);

  const configs = stepConfigsKey?.configs;
  // const isFaceMatchEnabled = getConfigurationCode(
  //   stepConfigs?.configs,
  //   CONFIG_MASTER_ENUM.FACE_MATCH
  // );
  //const isFaceMatchEnabled = getStepMaster(stepMaster, STEP_MASTER_ENUM.KEY_FACEVERIFICATION_PAGE_PAGE);

  const isFaceMatchEnabled = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.KEY_FACEVERIFICATION_PAGE_PAGE
  )?.isEnabled;

  const settings = getParametersFromLocalStorage("settings");

const manualkeypickup =
  settings?.find((setting) => setting.parameterName === "ManualKeyPickup")
    ?.parameterValue?.toLowerCase() === "true" ?? true;

  saveIntoLocalStorage("faceMatch", isFaceMatchEnabled);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = getParametersFromLocalStorage("token");
  const resetTimerAndClosePopUp = () => {
    if (!timerValue) {
      setTimerValue(timeLimit);
    }
    setRestartTimer(true);
    setShowModal(false);
  };

  const timerCounter = (value) => {
    setTimerValue(value);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const stopTimer = () => {
    setRestartTimer(false);
  };

  const closeErrorModal = () => {
    setErrorModalData((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };
  const confirmationDataChangeHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setConfirmationNumberData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const pad = (number) => {
    return number < 10 ? "0" + number : number;
  };
  const tileDisabled = ({ activeStartDate, date, view }) => {
    if (view === "month") {
      return date.getMonth() !== activeStartDate.getMonth();
    }
  };
  // const handleDateChange = (date) => {
  //   setSelectedDate(date);
  //   setShowCalendar(false);
  //   const month = pad(date.getMonth() + 1);
  //   const day = pad(date.getDate());
  //   const year = date.getFullYear();
  //   const fullDate = day + "/" + month + "/" + year;
  //   document.getElementsByName("selectedDate")[0].value = fullDate;
  // };
  const handleDateChange = (date) => {
    // const month = pad(date.getMonth() + 1);
    // const day = pad(date.getDate());
    // const year = date.getFullYear();
    // const fullDate = day + "/" + month + "/" + year;
    setSelectedDate(date);
    setShowCalendar(false);
    const fullDate = formatDate(date);
    document.getElementsByName("selectedDate")[0].value = fullDate;
  };

  const getConfirmationDetails = async () => {
    try {
      setLoading(true);
      // if (selectedDate !== null && selectedDate !== undefined) {
      //   let checkoutDateFormatted = formatSysDate(selectedDate);
      //   confirmationNumberData.checkoutDate = checkoutDateFormatted;
      // }
      if (selectedDate !== null && selectedDate !== undefined) {
        let checkoutDateFormatted = formatDate(selectedDate);
        confirmationNumberData.checkoutDate = checkoutDateFormatted;
      }
      setLoading(true);
      //let form = formatSysDate(selectedDate);
      //confirmationNumberData.checkinDate = form;
      const newObj = {
        LastName: confirmationNumberData.lastName?.trimEnd()?.trimStart(),
        ConfirmationNo: confirmationNumberData.confirmationNumber?.replace(
          " ",
          ""
        ),
        PropertyCode: propertyData.data.propertyCode,
        RoomNumber: confirmationNumberData.roomNumber?.replace(" ", ""),
        CheckOutDate: confirmationNumberData.checkoutDate,
        ReservationStatus: "inhouse",
      };
      const response = await getReservationDetails(newObj, token);
      if (response.data.statusCode === 200 && response.data.data != null) {
        reservationRef.current = response.data.data;
        if (response.data.data?.isCheckinAllowed) {
          setLoading(false);
          setErrorModalData((state) => ({
            ...state,
            toggleError: true,
            errorMessage: t(
              "Sorry, unable to fetch reservation. Reservation is already checked out."
            ),
          }));
          return;
        } else {
          dispatch(userReservationDetailsCheckoutPage(response.data.data));
          dispatch(userReservationDetailsPassport(response.data.data));
          setConfirmationNumberData({
            lastName: "",
            checkinDate: "",
            confirmationNumber: "",
          });
          localStorage.setItem(
            "confirmationNo",
            response.data.data.pmsConfirmationNo
          );
          localStorage.setItem(
            "reservationNameID",
            response.data.data.reservationNameID
          );
         

          
          // if ((isFaceMatchEnabled !== undefined && isFaceMatchEnabled !== null) && manualkeypickup === true) {

          //  const docresponse = await fetchProfileDocuments(
          //         {
          //           ConfirmationNo: response.data.data.pmsConfirmationNo,
          //           type: "CHECKIN",
          //         },
          //         token
          //       );

          //   if (docresponse.data.statusCode === 200 && docresponse.data != null) {
          //      setLoading(false);
          //      setShowManualAuthModal(true); // Your modal state
          //      return;
          //   }

          //   // Manual key pickup enabled → fetch profiles
          // } else if (
          //   isFaceMatchEnabled !== undefined && isFaceMatchEnabled !== null
          // ) {
          //   await dispatch(
          //     fetchProfiles({
          //       ConfirmationNo: response.data.data.pmsConfirmationNo,
          //       ReservationNameID: response.data.data.reservationNameID,
          //       token,
          //     })
          //   ).then(async (profileList) => {
          //     let reservation = profileList?.payload?.reservation;
          //     dispatch(userReservationDetailsPassport(reservation));
          //     setLoading(false);
          //     navigate(FACE_VERIFICATION + "/pickupkey", { replace: true });
          //   });
          // } else {
          //   setLoading(false);
          //   navigate(KEY + "/key", { replace: true });
          //}

          // if (isFaceMatchEnabled !== undefined && isFaceMatchEnabled !== null) {
          //     // Face match ON → fetch profiles
          //     const profileList = await dispatch(
          //       fetchProfiles({
          //         ConfirmationNo: response.data.data.pmsConfirmationNo,
          //         ReservationNameID: response.data.data.reservationNameID,
          //         token,
          //       })
          //     );

          //     const profiles = profileList?.payload?.profiles ?? [];
          //   if (profiles.length > 0) {
          //     // Profile exists → go to face verification
          //     let reservation = profileList?.payload?.reservation;
          //     dispatch(userReservationDetailsPassport(reservation));
          //     setLoading(false);
          //     navigate(FACE_VERIFICATION + "/pickupkey", { replace: true });
          //     //uncomment to show badge
          //     //navigate(FACE_VERIFICATION + "/pickupkey", { replace: true ,state: {reservationData: response.data.data }});
          //   } else {
          //     // No profile → show manual authentication modal
          //     setLoading(false);
          //     setShowManualAuthModal(true);
          //   }
          // }
          // else {
          //   // Face match OFF → directly go to KEY screen
          //   setLoading(false);
          //   navigate(KEY + "/key", { replace: true });

          //   //uncomment to show badge
          //  //navigate(KEY + "/key", { replace: true ,  state: {reservationData: response.data.data }});
          // }

          if (isFaceMatchEnabled !== undefined && isFaceMatchEnabled !== null) {
            let keyFaceVerification = true;
            saveIntoLocalStorage("keyFaceVerification", keyFaceVerification);
            
            await dispatch(
              fetchProfilesForKeyPickup({
                ConfirmationNo: response.data.data.pmsConfirmationNo,
                ReservationNameID: response.data.data.reservationNameID,
                token,
              })
            ).then(async (profileList) => {
              let reservation = profileList?.payload?.reservation;
              
              dispatch(userReservationDetailsPassport(reservation));
              setLoading(false);
              //navigate(FACE_VERIFICATION + "/pickupkey", { replace: true });
                navigate(FACE_VERIFICATION + "/pickupkey", { replace: true });
            });
          } else if (manualkeypickup == true || manualkeypickup == "true") {
            //if facial recognition is not enabled and manual key pickup is enabled
            const docresponse = await fetchProfileDocuments(
              {
                ConfirmationNo: response.data.data.pmsConfirmationNo,
                type: "CHECKIN",
              },
              token
            );

            if (docresponse.status === 200 && docresponse.data != null) {
              // If profiles exist in the document response
              const profiles = docresponse.data.data;

              // Check if profiles exist and if any profile contains the FaceImageBase64Image
              const profileWithImage = profiles.find(
                (profile) => profile.FaceImageBase64Image
              );

              if (profileWithImage) {
                // Profile with FaceImageBase64Image exists — navigate to key pickup
                setLoading(false);
                // navigate(KEY + "/key", { replace: true });

                console.log("response.data.data", response.data.data);

                //uncomment to show badge
                navigate(KEY + "/key", { replace: true ,  state: {reservationData: response.data.data }});

                return;
              } else {
                // No profiles found or FaceImageBase64Image not available — show manual authentication modal
                setLoading(false);
                setShowManualAuthModal(true); // Show your modal state
                return;
              }
            }
            // await dispatch(
            //   fetchProfiles({
            //     ConfirmationNo: response.data.data.pmsConfirmationNo,
            //     ReservationNameID: response.data.data.reservationNameID,
            //     token,
            //   })
            // ).then(async (profileList) => {
            //   const profiles = profileList?.payload?.profiles ?? [];
            //   if (profiles.length === 0) {
            //     ;
            //     // No profiles found(checkin not done from kiosk) — show manual auth modal
            //     setLoading(false);
            //     setShowManualAuthModal(true); // Your modal state
            //     return;
            //   } else {
            //     ;
            //     // Profiles found — navigate to key pickup
            //     setLoading(false);
            //     navigate(KEY + "/key", { replace: true });
            //   }
            // });
           
            //setLoading(false);
            //setShowManualAuthModal(true);
            //return;
          } else {
            setLoading(false);
            //navigate(KEY + "/key", { replace: true });

            //uncomment to show badge
            navigate(KEY + "/key", { replace: true ,  state: {reservationData: response.data.data }});
          }

          return;
        }
      } else {
        setLoading(false);
        setErrorModalData((state) => ({
          ...state,
          toggleError: true,
          errorMessage: t(
            "Sorry, unable to fetch reservation. Reservation is already checked out."
          ),
        }));
        return;
      }
    } catch (error) {
      console.log("error2" + error);
      setLoading(false);
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t(error),
      }));
      return;
    }
  };

  const handleManualVerification = async () => {
    ;
    setShowManualAuthModal(false); // Hide modal
    //setFacialRecognisationFailed(false);
    let credentials = [];

    try {
      setLoading(true);

      const scanDataQR = await Promise.race([
        getScanDataFromWebhostQR({}),
        wait(30000),
      ]);

      if (scanDataQR?.data?.BarCodeData) {
        credentials = scanDataQR.data.BarCodeData.split(";");
      } else {
        setLoading(false);
        setErrorModalData({
          toggleError: true,
          errorMessage: t("QR scan failed. Please try again or contact staff."),
        });
        setTimeout(() => {
          handlebackPage();
        }, 4000);
      }

      const confirmNo = localStorage.getItem("confirmationNo");

      const response = await getManualAuthentication(
        {
          username: credentials[0],
          password: credentials[1],
          ConfirmationNo: confirmNo,
        },
        token
      );

      if (response.data.result === true) {
        // ✅ Navigate to Key Pickup page on success
        //navigate(KEY + "/key", { replace: true });
        //navigate(KEY + "/key", { replace: true ,  state: {reservationData: response.data.data }});

        navigate(KEY + "/key", {
          replace: true,
          state: { reservationData: reservationRef.current },
        });
      } else {
        setErrorModalData({
          toggleError: true,
          errorMessage: t("Manual authentication failed. Please try again."),
        });
      }
    } catch (err) {
      console.error("Manual auth error", err);
      setErrorModalData({
        toggleError: true,
        errorMessage: t("Something went wrong. Please contact staff."),
      });
    } finally {
      setLoading(false);
    }
  };

  const handlebackPage = () => {
    try {
      homePageHandler(dispatch, navigate);
    } catch (error) {
      console.error("Error capturing image:", error);
    }
  };
      //KC-447 Timer need to restart when user interaction is involved
 useUserActivity(() => {
    setTimerValue(timeLimit); 
  });

  const addLog = (response, request, message) => {
    const confirmationNo = localStorage.getItem("confirmationNo");
    const data = {
      ActionName: "Key Reservation Search",
      Message: message ?? "",
      ControllerName: "kiosk",
      Request: request ?? "",
      PMSConfirmationNo: confirmationNo,
      AppType: "kiosk",
      Response: response ?? "",
      PropertyCode: propertyData?.data?.propertyCode,
    };
    dispatch(postAuditLog({ data, token }));
  };

  return (
    <div>
      <main>
        <div className="main-content confirmation-white">
          <div
            style={{
              position: "absolute",
              top: "40px",
              right: "20px",
              zIndex: 10,
            }}
          >
            <PriorityBadge />
          </div>
          <div>
            <Header
              onClick={handlebackPage}
              setShowModal={setShowModal}
              isHome={true}
              title={t("Welcome!")}
              subTitle={t("Please choose your way to Key Pickup")}
            />
          </div>

          {configs && (
            <>
              <CheckInCheckOutToggleForm
                confirmationNumberData={confirmationNumberData}
                confirmationDataChangeHandler={confirmationDataChangeHandler}
                selectedDate={selectedDate}
                setShowCalendar={setShowCalendar}
                showCalendar={showCalendar}
                handleDateChange={handleDateChange}
                tileDisabled={tileDisabled}
                getConfirmationDetails={getConfirmationDetails}
                type="Key"
                stepConfigs={configs}
              />
            </>
          )}
        </div>

        <KeyFooter
          page={"search"}
          showModal={showModal}
          openModal={openModal}
          timerCounter={timerCounter}
          timerValue={timerValue}
          restartTimer={restartTimer}
          stopTimer={stopTimer}
          timeLimit={timeLimit}
          isFaceMatchEnabled={isFaceMatchEnabled}
        />

        <LoaderPopup loading={loading} />
        <ErrorPopup
          closeErrorModal={closeErrorModal}
          erroModalData={erroModalData}
        />
      </main>
      {showModal && (
        <HomePageCard
          resetTimerAndClosePopUp={resetTimerAndClosePopUp}
          showModal={showModal}
        />
      )}

      <ManualAuthenticationModal
        open={showManualAuthModal}
        onAuthenticate={handleManualVerification}
        onCancel={handleManualAuthCancel}
        backToHomePage={handlebackPage}
      />
    </div>
  );
};

export default KeyReservationSearch;
